import React, { useState, type ComponentType } from 'react';
import { useLeftSidebarState } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
import { PageLayout, type PageLayoutProps } from '@atlassian/jira-navigation-system/src/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';

// Used when the navx-full-height-sidebar feature flag is enabled
const PageLayoutWithFHSChanges = ({ children, ...props }: PageLayoutProps) => {
	const { isCollapsed } = useLeftSidebarState();
	const [defaultSideNavCollapsed] = useState(isCollapsed);

	return (
		<PageLayout
			{...props}
			defaultSideNavCollapsed={defaultSideNavCollapsed}
			isSideNavShortcutEnabled
		>
			{children}
		</PageLayout>
	);
};

export const JiraPageLayout: ComponentType<PageLayoutProps> = componentWithFG(
	'navx-full-height-sidebar',
	PageLayoutWithFHSChanges,
	PageLayout,
);
